import gql from 'graphql-tag';

export const PIXEL_TRACKING_APPS_QUERY = gql`
  query PixelAppsQuery(
    $rowsPerPage: Int
    $after: String
    $before: String
    $filter: PixelTrackingAppsFilterInput
    $sort: SortInput!
  ) {
    pixelTrackingApps(first: $rowsPerPage, after: $after, before: $before, filter: $filter, sort: $sort) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          id
          appId
          name
          domain
          timezone
          pageUniquePart
          facebookPixelId
          estimatedMonthlyTraffic
          trafficEnabled
        }
      }
    }
  }
`;

export const PIXEL_TRACKING_APP_INSTRUCTIONS_QUERY = gql`
  query PixelAppInstructionsQuery($id: ID!) {
    pixelTrackingApp(id: $id) {
      id
      instructions
    }
  }
`;
